export const postStatus: any = {
  draft: "下書き",
  publish: "公開済み",
  scheduled: "予約記事",
};
